module.exports = __webpack_public_path__ + "static/media/water4.fe9244ae.jpg";